<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
    label: string;
    value: string;
    caption: string;
    delta: {
        class: string;
        icon: Component;
        text: string;
    };
}>();
</script>

<template>
    <div
        class="relative flex min-w-0 flex-col rounded-2xl border bg-card p-5 shadow-sm"
    >
        <div class="flex flex-wrap items-start justify-between gap-2">
            <span
                class="min-w-0 flex-1 text-sm font-semibold leading-snug text-foreground"
            >
                {{ label }}
            </span>
            <span
                class="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold tabular-nums"
                :class="delta.class"
            >
                <component :is="delta.icon" class="size-3" />
                {{ delta.text }}
            </span>
        </div>
        <span
            class="mt-5 text-4xl font-bold leading-none tracking-tight tabular-nums"
        >
            {{ value }}
        </span>
        <span class="mt-2 text-[13px] leading-relaxed text-muted-foreground">
            {{ caption }}
        </span>
    </div>
</template>
